import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateRange } from 'shared';
import {
    ISupplierResourcesService,
    SUPPLIER_RESOURCES_SERVICE_IMPL,
} from 'dm-src/services/suppliers/isupplier-resources-service';
import { SupplierWorktimeSettings } from 'dm-src/dtos/supplier-worktime-settings';
import moment from 'moment';
import { environment } from 'dm-src/environments/environment';
import { SupplierResourcesService } from 'dm-src/app/modules/supplier-resources/supplier-resources.service';
import { ServiceBaseService } from 'projects/shared/src/lib/services/service-base.service';

@Component({
    selector: 'app-worktime-settings',
    templateUrl: './worktime-settings.component.html',
    styleUrls: ['./worktime-settings.component.scss'],
})
export class WorktimeSettingsComponent implements OnInit {
    private readonly _defaultLogisticsEnvironmentName = 'staging_hu';

    public initialDateRange: Date[];
    public initialValue: string;
    public suppierWorktimeSettings: SupplierWorktimeSettings;
    public selectedSupplierRegionID: string;

    @ViewChild('deliveryPlanViewerModal', { static: true })
    private _deliveryPlanViewerModal: TemplateRef<unknown>;

    constructor(
        @Inject(SUPPLIER_RESOURCES_SERVICE_IMPL)
        private _supplierResourcesAPIService: ISupplierResourcesService,
        private _supplierResourcesService: SupplierResourcesService,
        private _modalService: NgbModal,
        private _sanitizer: DomSanitizer
    ) {
        this.suppierWorktimeSettings = new SupplierWorktimeSettings();
        this.initialDateRange = [];
        this.selectedSupplierRegionID = this._supplierResourcesService.currentSupplierRegionID;
    }

    ngOnInit(): void {
        this._supplierResourcesAPIService.getWorktimeSettings().subscribe((response) => {
            if (response.status === 200) {
                this.suppierWorktimeSettings = response.body;
                const startDate = new Date(response.body.worktimeRegistrationStart);
                const endDate = new Date(response.body.worktimeRegistrationEnd);
                this.initialDateRange.push(startDate);
                this.initialDateRange.push(endDate);
                this.initialValue =
                    moment(startDate).format(environment.worktimeRegistrationDateFormat) +
                    ' - ' +
                    moment(endDate).format(environment.worktimeRegistrationDateFormat);
            }
        });
    }

    public onRegistrationButtonClicked(isEnabled: boolean) {
        this.suppierWorktimeSettings.isWorktimeRegistrationEnabled = isEnabled;
        this.setWorktimeSettings();
    }

    public onDateRangeSelected(dates: DateRange) {
        if (
            dates.dateFrom === null ||
            dates.dateFrom === undefined ||
            dates.dateTo === undefined
        ) {
            return;
        }

        dates.dateFrom += ' 00:00:00';
        dates.dateTo += ' 23:59:59';

        this.suppierWorktimeSettings.worktimeRegistrationStart = dates.dateFrom;
        this.suppierWorktimeSettings.worktimeRegistrationEnd = dates.dateTo;

        this.setWorktimeSettings();
    }

    public onSupplierRegionChanged(supplierRegionID: string) {
        this.selectedSupplierRegionID = supplierRegionID;
        this._supplierResourcesService.changeSupplierRegion(supplierRegionID);
    }


    public openDeliveryPlanViewer(): void
    {
        if (!this.selectedSupplierRegionID)
            return;

        this._modalService.open(this._deliveryPlanViewerModal, {
            windowClass: 'modal-holder modal-fullscreen logistics-map-modal-window',
            size: 'xl',
        });
    }

    private setWorktimeSettings(): void {
        this._supplierResourcesAPIService
            .setWorktimeSettings(this.suppierWorktimeSettings)
            .subscribe();
    }


    private getLogisticsEnvironmentName(): string {
        const environmentName = ServiceBaseService.getEnvironment;

        if (!environmentName || environmentName === 'dev') {
            return this._defaultLogisticsEnvironmentName;
        }

        return environmentName;
    }
}
